import { Box, HStack, Text, Select, Button, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import { ListBox } from '../../molecules/ListBox';
import { DivisionEnum, MessageType } from './MessageBody';

interface props {
  MessageInfo: MessageType | undefined;
  Division: number;
  ChooseTitle: string;
  NoticeTitle: string;
  ChooseList: Array<number>;
  searchRefA: React.MutableRefObject<HTMLSelectElement | null>;
  searchRefB: React.MutableRefObject<HTMLSelectElement | null>;
  RightButtonOnClick: (
    searchRefA: React.MutableRefObject<HTMLSelectElement | null>,
    Division: number
  ) => void;
  LeftButtonOnClick: (
    searchRefB: React.MutableRefObject<HTMLSelectElement | null>,
    Division: number
  ) => void;
  AllChooseButtonClick: (
    searchRefA: React.MutableRefObject<HTMLSelectElement | null>,
    Division: number
  ) => void;
  AllReleaseButtonClick: (Division: number) => void;
}

export const DispType = {
  Search: 1,
  Choose: 2
};

export const InboundEnum = {
  None: 0,
  Upper: 1,
  Lower: 2
};

export const CourseTrains = {
  None: 0,
  First: 1,
  Second: 2,
  Third: 3,
  Fourth: 4,
  Fifth: 5,
  Other: 6, //回送、教習車等？
  NotDrive: 7,
  All: 8
};

export const CourseSignages = {
  None: 0,
  First: 1,
  Third: 3,
  Fourth: 4,
  Fifth: 5
};

const MessageListBox: React.FC<props> = (props) => {
  const {
    MessageInfo,
    Division,
    ChooseTitle,
    NoticeTitle,
    ChooseList,
    searchRefA,
    searchRefB,
    RightButtonOnClick,
    LeftButtonOnClick,
    AllChooseButtonClick,
    AllReleaseButtonClick
  } = props;

  const [tramCourse, setTramCourse] = useState(0);
  const [selectInbound, setSelectInbound] = useState(InboundEnum.None);
  const [trainCourse, setTrainCourse] = useState(0);
  const [trainGroup, setTrainGroup] = useState(0);
  return (
    <>
      <Box mt={20}>
        <HStack gridColumn='1/2'>
          <Text w='100%' align='right'>
            通知先の設定：
          </Text>
          {Division === DivisionEnum.Tram && (
            <Select
              w='42%'
              onChange={(e) => setTramCourse(Number(e.target.value))}
            >
              <option value={CourseSignages.None}>
                系統を選択してください
              </option>
              <option value={CourseSignages.First}>1系統</option>
              <option value={CourseSignages.Third}>3系統</option>
              <option value={CourseSignages.Fourth}>4系統</option>
              <option value={CourseSignages.Fifth}>5系統</option>
            </Select>
          )}
          {Division === DivisionEnum.Train && (
            <Select
              w='42%'
              onChange={(e) => setTrainCourse(Number(e.target.value))}
            >
              <option value={CourseTrains.None}>系統を選択してください</option>
              <option value={CourseTrains.All}>全系統</option>
              <option value={CourseTrains.First}>1系統</option>
              <option value={CourseTrains.Second}>2系統</option>
              <option value={CourseTrains.Third}>3系統</option>
              <option value={CourseTrains.Fourth}>4系統</option>
              <option value={CourseTrains.Fifth}>5系統</option>
              <option value={CourseTrains.Other}>その他系統</option>
              <option value={CourseTrains.NotDrive}>運転中以外</option>
            </Select>
          )}
        </HStack>
        <HStack gridColumn='1/2'>
          <Text w='100%' align='right'>
            {ChooseTitle + '：'}
          </Text>
          {Division === DivisionEnum.Tram && (
            <Select
              w='42%'
              onChange={(e) => setSelectInbound(Number(e.target.value))}
            >
              <option value={InboundEnum.None}>選択してください</option>
              <option value={InboundEnum.Upper}>上り</option>
              <option value={InboundEnum.Lower}>下り</option>
            </Select>
          )}
          {Division === DivisionEnum.Train && (
            <Select
              w='42%'
              onChange={(e) => setTrainGroup(Number(e.target.value))}
            >
              <option value={0}>{'全車両'}</option>
              {MessageInfo?.train_groups !== undefined &&
                MessageInfo.train_groups.map((data, i) => {
                  return (
                    <option key={'trainGroup_' + i} value={data.id}>
                      {data.name}
                    </option>
                  );
                })}
            </Select>
          )}
        </HStack>
      </Box>
      <HStack gridColumn='2/2' ml={40}>
        <ListBox
          DispDatas={MessageInfo}
          Division={Division}
          DispDataType={DispType.Search}
          Title={'検索結果'}
          ChooseList={ChooseList}
          Course={Division === DivisionEnum.Train ? trainCourse : tramCourse}
          Condition={
            Division === DivisionEnum.Train ? trainGroup : selectInbound
          }
          searchRefA={searchRefA}
          searchRefB={searchRefB}
        />
        <VStack>
          <Button
            mt={10}
            w='50px'
            h='30px'
            fontSize='20px'
            bg='yellow.300'
            onClick={() => RightButtonOnClick(searchRefA, Division)}
          >
            →
          </Button>
          <Button
            w='50px'
            h='30px'
            fontSize='14px'
            bg='yellow.300'
            onClick={() => AllChooseButtonClick(searchRefA, Division)}
          >
            全選択
          </Button>
          <Button
            w='50px'
            h='30px'
            fontSize='14px'
            bg='yellow.300'
            onClick={() => AllReleaseButtonClick(Division)}
          >
            全解除
          </Button>
          <Button
            w='50px'
            h='30px'
            fontSize='20px'
            bg='yellow.300'
            onClick={() => LeftButtonOnClick(searchRefB, Division)}
          >
            ←
          </Button>
        </VStack>
        <ListBox
          DispDatas={MessageInfo}
          Division={Division}
          DispDataType={DispType.Choose}
          Title={NoticeTitle}
          ChooseList={ChooseList}
          Course={Division === DivisionEnum.Train ? trainCourse : tramCourse}
          Condition={
            Division === DivisionEnum.Train ? trainGroup : selectInbound
          }
          searchRefA={searchRefA}
          searchRefB={searchRefB}
        />
      </HStack>
    </>
  );
};

export default React.memo(MessageListBox);
